import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import Main from './Main';
import * as serviceWorker from "./serviceWorker";

// TAMBAHAN BACA PORT
// BIAR BISA DI CUSTOM
var WS_PORT=8001;
if (document.getElementById('root') !== null && document.getElementById('root').attributes.getNamedItem('server-port') !== null) {
  if (parseInt(document.getElementById('root').attributes.getNamedItem('server-port').value) > 0) {
    WS_PORT=parseInt(document.getElementById('root').attributes.getNamedItem('server-port').value);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Main port={WS_PORT} />
  </React.StrictMode>,
  document.getElementById('root')
);

//ReactDOM.hydrate(<Main />, document.getElementById("root"));

serviceWorker.unregister();
